import * as React from 'react';
import styled from 'styled-components';

import RoomView from './views/RoomView';
import { IRoom } from './types';
import t from './locales';

const RoomsView = styled.div`
  padding: 1em;
`;

interface IProps {
  rooms: IRoom[];
  setRooms: Function;
} 

const Rooms: React.FC<IProps> = (props) => {
  const { rooms, setRooms } = props;

  function addAdults(roomIndex: number, amount: number) {
    const room = rooms[roomIndex];
    const newRooms = [...rooms];
    const newCount = room.adults + amount;
    if (newCount < 1) {
      if (roomIndex === 0) {
        return;
      } else {
        newRooms.splice(roomIndex, 1);
      }
    } else {
      newRooms.splice(roomIndex, 1, { ...room, adults: newCount });
    }
    setRooms(newRooms);
  }

  function addChildren(roomIndex: number, amount: number) {
    const defaultChildAge = 0;
    const room = rooms[roomIndex];
    const newRooms = [...rooms];
    if (room.child_ages.length + amount < 0) {
      newRooms.splice(roomIndex, 1, { ...room, child_ages: [] });
      setRooms(newRooms);
      return;
    }
    let newChildAges = [...room.child_ages];
    if (amount > 0) {
      newChildAges = [...room.child_ages, ...Array(amount).fill(defaultChildAge)];
    } else if (amount < 0) {
      newChildAges.splice(amount, -(amount));
    }
    newRooms.splice(roomIndex, 1, { ...room, child_ages: newChildAges });
    setRooms(newRooms);
  }

  function handleAgeChange(event: React.ChangeEvent): void {
    const roomIndex: number = Number(event.currentTarget.getAttribute('data-room-index'));
    const childIndex: number = Number(event.currentTarget.getAttribute('data-child-index'));
    const value: number = Number((event.currentTarget as any).selectedIndex);
    const newRoom = { ...rooms[roomIndex] };
    const newRooms = [...rooms];
    if (newRoom.child_ages[childIndex] != null && value >= 0 && value <= 12) {
      newRoom.child_ages.splice(childIndex, 1, value);
      setRooms(newRooms);
    }
  }

  function renderChildAges(room: IRoom, roomIndex: number) {
    if (room.child_ages.length === 0) { return null; }
    const elements = room.child_ages.map((age: number, index: number) => {
      const key = `room-${roomIndex}-child-${index}`;
      return (
        <div className="age-input__row" key={key}>
          <span>{t.children()} {index + 1}</span>
          <select value={age} data-room-index={roomIndex} data-child-index={index} onChange={handleAgeChange}>
            {Array(13).fill(0).map((zero: number, optionIndex: number) => (
              <option key={`${key}-${optionIndex}`}>{zero + optionIndex}</option>
            ))}
          </select>
        </div>
      );
    });
    return (
      <div className="age-input">
        <p className="input-title" style={{ margin: '0.25em 0 0.5em' }}>{t.childAges()}</p>
        {elements}
      </div>
    );
  }

  return (
    <RoomsView>
      {rooms.map((room: IRoom, i: number) => {
        return (
          <RoomView key={`room-${i}`}>
            <div className="base-input">
              <div className="base-input__row">
                <p className="input-title">{t.adults()}</p>
                <div className="base-input__count">
                  <button onClick={() => { addAdults(i, -1); }}><i className="icon-minus" /></button>
                  <span>{room.adults}</span>
                  <button onClick={() => { addAdults(i, 1); }}><i className="icon-plus" /></button>
                </div>
              </div>
              <div className="base-input__row">
                <p className="input-title">
                  {t.children()}
                  <span className="base-input__note">{t.twelveAndUnder()}</span>
                </p>
                <div className="base-input__count">
                  <button onClick={() => { addChildren(i, -1) }}><i className="icon-minus" /></button>
                  <span>{room.child_ages.length}</span>
                  <button onClick={() => { addChildren(i, 1) }}><i className="icon-plus" /></button>
                </div>
              </div>
            </div>
            {renderChildAges(room, i)}
          </RoomView>
        )
      })}
    </RoomsView>
  );
}

export default Rooms;
